module.exports = __webpack_public_path__ + "nc_static/media/dd_contact hotline.26bbc6be.svg";